module.exports = "/assets/f186c98ea463b74e449049a2bb53c432.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/BX.png
// module id = 2375
// module chunks = 0